import { css } from '@emotion/react';

export const backgroundGrayPattern = css({
  overflow: 'hidden',
  position: 'relative',
  '&::before': {
    background:
      "url('//d2slcw3kip6qmk.cloudfront.net/marketing/pages/chart/Homepage/background.svg')",
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    zIndex: -99,
    height: '100%',
    content: '""',
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  }
});
